import { defineMessages } from '../define';

export const notifications = defineMessages({
  en: {
    'notifications.title': 'Notifications',
    'notifications.description':
      'Rules that turn an event into an alert somewhere a person will actually see it.',
    'notifications.add': 'Add rule',

    // Channel names. The wire identifiers (BROWSER, EMAIL, …) never change; only
    // the label beside them is translated, and the two product names are not.
    'notifications.channel.BROWSER': 'Browser',
    'notifications.channel.EMAIL': 'Email',
    'notifications.channel.WEBHOOK': 'Webhook',
    'notifications.channel.LINE_MESSAGING_API': 'LINE Messaging API',

    'notifications.column.name': 'Name',
    'notifications.column.channel': 'Channel',
    'notifications.column.destination': 'Destination',
    'notifications.column.events': 'Events',
    'notifications.column.scope': 'Scope',

    'notifications.allEvents': 'All events',
    'notifications.target.thisBrowser': 'This browser',
    'notifications.pause': 'Pause {name}',
    'notifications.activate': 'Activate {name}',
    'notifications.rowActions': 'Actions for {name}',

    'notifications.created': 'Rule created',
    'notifications.updated': 'Rule updated',
    'notifications.deleted': 'Rule deleted',
    'notifications.test.delivered': 'Test delivered',
    'notifications.test.failed': 'Test failed',
    'notifications.requestFailed':
      'The request could not be completed. Check that the gateway is reachable.',

    'notifications.delete.title': 'Delete {name}?',
    'notifications.delete.description': 'Alerts stop going to this destination immediately.',
    'notifications.delete.confirm': 'Delete rule',

    'notifications.empty.title': 'No notification rules',
    'notifications.empty.description':
      'A rule picks the events you care about and the place they should land — an inbox, a chat channel, or this browser.',

    'notifications.browser.unsupported':
      'This browser does not support desktop notifications. Rules on the browser channel will not reach it.',
    'notifications.browser.title': 'Desktop notifications',
    'notifications.browser.granted': 'Allowed',
    'notifications.browser.denied': 'Blocked',
    'notifications.browser.notAsked': 'Not asked',
    'notifications.browser.description':
      'Granting this lets rules on the browser channel raise a desktop notification while the console is open, so you do not have to keep the tab in view.',
    'notifications.browser.allow': 'Allow notifications',
    'notifications.browser.deniedHint':
      'Blocked in the browser. Re-enable it in the site settings for this address.',

    'notifications.dialog.createTitle': 'Add rule',
    'notifications.dialog.editTitle': 'Edit rule',
    'notifications.dialog.description':
      'Rules run in order of nothing in particular; a matching event fires every rule that subscribes to it.',
    'notifications.field.name': 'Name',
    'notifications.field.namePlaceholder': 'Page the on-call inbox',
    'notifications.field.channel': 'Channel',
    'notifications.field.events': 'Events',
    'notifications.field.sessions': 'Sessions',
    'notifications.field.direction': 'Bank transactions',
    'notifications.sessions.all': 'All sessions, including ones added later',
    'notifications.sessions.empty': 'No sessions yet.',
    'notifications.scope.sessions': '{count} session(s)',
    'notifications.direction.all': 'Money in and out',
    'notifications.direction.CREDIT': 'Money in only',
    'notifications.direction.DEBIT': 'Money out only',
    'notifications.noEvents': 'No events selected — this rule will fire on all of them.',
    'notifications.sendTest': 'Send test',
    'notifications.sendTestHint':
      'Send one message through these settings right now, without saving',
    'notifications.create': 'Create rule',

    'notifications.browserChannel.note':
      'Nothing to configure. Browser alerts go to whoever has the console open and has allowed notifications for this address.',
    'notifications.email.label': 'Recipient address',
    'notifications.email.hint': 'Sent through the SMTP server configured under Settings → Integrations.',
    'notifications.webhook.hint':
      'A plain POST with the alert text. For signed event payloads use a webhook endpoint instead.',
    'notifications.line.tokenLabel': 'Channel access token',
    'notifications.line.tokenPlaceholder': 'Leave blank to keep the saved token',
    'notifications.line.savedToken':
      'Using the saved token ending {suffix}. Type a new one only to replace it — Send test checks the saved one.',
    'notifications.line.tokenHint':
      'From the LINE Developers console, under your Messaging API channel.',
    'notifications.line.targetLabel': 'Target id',
    'notifications.line.targetHint': 'The user, group or room to push the message to.',

    'notifications.error.recipientRequired': 'A recipient address is required.',
    'notifications.error.urlRequired': 'An http or https URL is required.',
    'notifications.error.targetRequired': 'A target id is required.',
    'notifications.error.tokenRequired': 'A channel access token is required.',
  },
  th: {
    'notifications.title': 'การแจ้งเตือน',
    'notifications.description':
      'กฎที่เปลี่ยนเหตุการณ์ให้กลายเป็นการแจ้งเตือนในที่ที่มีคนเห็นจริง ๆ',
    'notifications.add': 'เพิ่มกฎ',

    'notifications.channel.BROWSER': 'เบราว์เซอร์',
    'notifications.channel.EMAIL': 'อีเมล',
    'notifications.channel.WEBHOOK': 'Webhook',
    'notifications.channel.LINE_MESSAGING_API': 'LINE Messaging API',

    'notifications.column.name': 'ชื่อ',
    'notifications.column.channel': 'ช่องทาง',
    'notifications.column.destination': 'ปลายทาง',
    'notifications.column.events': 'เหตุการณ์',
    'notifications.column.scope': 'ขอบเขต',

    'notifications.allEvents': 'ทุกเหตุการณ์',
    'notifications.target.thisBrowser': 'เบราว์เซอร์นี้',
    'notifications.pause': 'หยุด {name} ชั่วคราว',
    'notifications.activate': 'เปิดใช้งาน {name}',
    'notifications.rowActions': 'การทำงานสำหรับ {name}',

    'notifications.created': 'สร้างกฎแล้ว',
    'notifications.updated': 'อัปเดตกฎแล้ว',
    'notifications.deleted': 'ลบกฎแล้ว',
    'notifications.test.delivered': 'ส่งข้อความทดสอบแล้ว',
    'notifications.test.failed': 'ส่งข้อความทดสอบไม่สำเร็จ',
    'notifications.requestFailed': 'ดำเนินการตามคำขอไม่สำเร็จ กรุณาตรวจสอบว่าเกตเวย์เชื่อมต่อได้',

    'notifications.delete.title': 'ลบ {name} หรือไม่',
    'notifications.delete.description': 'การแจ้งเตือนจะหยุดส่งไปยังปลายทางนี้ทันที',
    'notifications.delete.confirm': 'ลบกฎ',

    'notifications.empty.title': 'ยังไม่มีกฎการแจ้งเตือน',
    'notifications.empty.description':
      'กฎหนึ่งข้อคือการเลือกเหตุการณ์ที่คุณสนใจ พร้อมกับปลายทางที่จะให้แจ้งเตือนไป ไม่ว่าจะเป็นกล่องอีเมล ห้องแชท หรือเบราว์เซอร์นี้',

    'notifications.browser.unsupported':
      'เบราว์เซอร์นี้ไม่รองรับการแจ้งเตือนบนเดสก์ท็อป กฎที่ใช้ช่องทางเบราว์เซอร์จะส่งมาไม่ถึง',
    'notifications.browser.title': 'การแจ้งเตือนบนเดสก์ท็อป',
    'notifications.browser.granted': 'อนุญาตแล้ว',
    'notifications.browser.denied': 'ถูกบล็อก',
    'notifications.browser.notAsked': 'ยังไม่ได้ขอสิทธิ์',
    'notifications.browser.description':
      'เมื่ออนุญาต กฎที่ใช้ช่องทางเบราว์เซอร์จะแสดงการแจ้งเตือนบนเดสก์ท็อปขณะที่เปิดคอนโซลอยู่ คุณจึงไม่ต้องคอยเปิดแท็บนี้ค้างไว้',
    'notifications.browser.allow': 'อนุญาตการแจ้งเตือน',
    'notifications.browser.deniedHint':
      'ถูกบล็อกไว้ในเบราว์เซอร์ กรุณาเปิดใหม่ในการตั้งค่าเว็บไซต์ของที่อยู่นี้',

    'notifications.dialog.createTitle': 'เพิ่มกฎ',
    'notifications.dialog.editTitle': 'แก้ไขกฎ',
    'notifications.dialog.description':
      'กฎไม่มีลำดับการทำงานที่แน่นอน เหตุการณ์ที่ตรงเงื่อนไขจะกระตุ้นทุกกฎที่สมัครรับเหตุการณ์นั้นไว้',
    'notifications.field.name': 'ชื่อ',
    'notifications.field.namePlaceholder': 'แจ้งเตือนกล่องอีเมลของเวรที่รับผิดชอบ',
    'notifications.field.channel': 'ช่องทาง',
    'notifications.field.events': 'เหตุการณ์',
    'notifications.field.sessions': 'เซสชัน',
    'notifications.field.direction': 'รายการเงินเข้า/ออก',
    'notifications.sessions.all': 'ทุกเซสชัน รวมถึงเซสชันที่เพิ่มในภายหลัง',
    'notifications.sessions.empty': 'ยังไม่มีเซสชัน',
    'notifications.scope.sessions': '{count} เซสชัน',
    'notifications.direction.all': 'ทั้งเงินเข้าและเงินออก',
    'notifications.direction.CREDIT': 'เฉพาะเงินเข้า',
    'notifications.direction.DEBIT': 'เฉพาะเงินออก',
    'notifications.noEvents': 'ยังไม่ได้เลือกเหตุการณ์ — กฎนี้จะทำงานกับทุกเหตุการณ์',
    'notifications.sendTest': 'ส่งทดสอบ',
    'notifications.sendTestHint': 'ส่งข้อความหนึ่งครั้งด้วยการตั้งค่านี้ทันที โดยไม่ต้องบันทึก',
    'notifications.create': 'สร้างกฎ',

    'notifications.browserChannel.note':
      'ไม่มีอะไรต้องตั้งค่า การแจ้งเตือนผ่านเบราว์เซอร์จะไปถึงทุกคนที่เปิดคอนโซลอยู่และอนุญาตการแจ้งเตือนสำหรับที่อยู่นี้ไว้',
    'notifications.email.label': 'อีเมลผู้รับ',
    'notifications.email.hint': 'ส่งผ่านเซิร์ฟเวอร์ SMTP ที่ตั้งค่าไว้ในหน้า ตั้งค่า → การเชื่อมต่อ',
    'notifications.webhook.hint':
      'เป็นการ POST ข้อความแจ้งเตือนแบบธรรมดา หากต้องการ payload ของเหตุการณ์ที่มีลายเซ็น ให้ใช้ webhook endpoint แทน',
    'notifications.line.tokenLabel': 'Channel access token',
    'notifications.line.tokenPlaceholder': 'เว้นว่างไว้เพื่อใช้โทเคนที่บันทึกไว้',
    'notifications.line.savedToken':
      'กำลังใช้โทเคนที่บันทึกไว้ ลงท้ายด้วย {suffix} พิมพ์ค่าใหม่เฉพาะเมื่อต้องการเปลี่ยนเท่านั้น — ปุ่มส่งทดสอบจะใช้โทเคนที่บันทึกไว้',
    'notifications.line.tokenHint': 'ดูได้จาก LINE Developers console ในช่อง Messaging API ของคุณ',
    'notifications.line.targetLabel': 'Target id',
    'notifications.line.targetHint': 'ผู้ใช้ กลุ่ม หรือห้องที่จะส่งข้อความไปหา',

    'notifications.error.recipientRequired': 'ต้องระบุอีเมลผู้รับ',
    'notifications.error.urlRequired': 'ต้องระบุ URL ที่ขึ้นต้นด้วย http หรือ https',
    'notifications.error.targetRequired': 'ต้องระบุ target id',
    'notifications.error.tokenRequired': 'ต้องระบุ channel access token',
  },
});
